import React, { forwardRef, useImperativeHandle, useRef ,useState} from "react";
import './InputStyles.css';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const InputField = forwardRef((props, ref) => {
    const inputRef = useRef(ref);

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current.focus();
        }
    }));
    const [openEye, setopenEye] = useState(false);
    const handleClickShowPassword = () => {
        setopenEye(!openEye);
      };

    return <div className="inputBox colBlock nopdng">
        {props?.showPwd && <span className="inputEyeIcon pointer">
         {openEye ?
            <Visibility className="invertGray" onClick={handleClickShowPassword} />
            :
            < VisibilityOff className="invertGray" onClick={handleClickShowPassword}/>
         }
         </span>}
          {props.type === "number" ?
            <input placeholder={props.placeholder} name={props.name} type={props.type} value={props.value} onChange={props.onChange} ref={inputRef} max={props.max} min={props.min} maxLength={props.maxLength} pattern={props.pattern} id={props.id} disabled={props.disabled} autoComplete={props.autocomplete ? props.autocomplete : "off"}/>
            : <input placeholder={props.placeholder} readOnly={props.readOnly} name={props.name} type={openEye ? 'text' : props.type} value={props.value} onChange={props.onChange} ref={inputRef} maxLength={props.maxLength} pattern={props.pattern} id={props.id} disabled={props.disabled} autoComplete={props.autocomplete ? props.autocomplete : "off"} onClick={props.onClick} autoFocus={props.error}/>
          }
              <label>{props.label}</label>
            {props.error && <span className="inputErrorMsg">{props.errorMsg}</span>}
        </div>

})
export default InputField;

// placeholder="placeholder"
// type="text"
// onChange=""
// label="name"